<div class="row">
    <div class="col-md-12 text-center">
        <img src="{{imagen}}" style="max-width:100%;cursor:pointer" class="modal-hover-opacity" />
    </div>
</div>